import React from "react";

export const isMobile = {
    Android: () => {
        return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: () => {
        return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: () => {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera: () => {
        return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: () => {
        return navigator.userAgent.match(/IEMobile/i);
    },
    any: () => {
        return (
            isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows()
        );
    },
};

export const delay = (function () {
    let timer = 0;
    return function (callback, ms) {
        clearTimeout(timer);
        timer = setTimeout(callback, ms);
    };
}());

export const isNumeric = (value) => {
    return /^-?\d+$/.test(value);
};

export function doBlockPage(otherMessage) {
    const message = otherMessage || 'Пожалуйста подождите. Идет обработка данных.';
    $('body').append('<div id="disable-all"><div class="modal-backdrop fade show"></div>' +
        '<div class="modal fade show" tabIndex="-1">' +
        '<div class="modal-dialog"><div class="modal-content"><div class="modal-body">' + message
        + '</div></div></div></div></div></div>');
}

export function doUnblockPage() {
    $('body').find('#disable-all').remove();
}

export function declension(num, expressions) {
    let result;
    let count;
    count = num % 100;
    if (count >= 5 && count <= 20) {
        result = expressions['2'];
    } else {
        count %= 10;
        if (count === 1) {
            result = expressions['0'];
        } else if (count >= 2 && count <= 4) {
            result = expressions['1'];
        } else {
            result = expressions['2'];
        }
    }
    return result;
}
